const useInputScroll = () => {
  const scrollToFirstError = () => {
    setTimeout(() => {
      const errorField = document.querySelector('input.error, select.error, i.fa.fa-circle-exclamation.fa-lg.color-red')
      if (errorField) {
        errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }, 500)
  }
  return { scrollToFirstError }
}

export default useInputScroll
